// 公共资源接口
// 2019-01-18 08:27:15

import HttpRequest from '@enterpaise/jslib/dk-axios';
import { uploadDomain } from '@enterpaise/configs/environment';

// 上传
export const UploadFile = data =>
    HttpRequest({
        url: uploadDomain,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
        timeout: 40000,
    });
